'use strict';

/**
 * Base Box Shadows:
 *
 * Euclid DS allowed box shadows: smaller subset of TW defaults.
 */ const boxShadow = {
    sm: '0px 1px 3px 0px light-dark(rgba(0, 0, 0, 0.06),rgba(255, 255, 255, 0.1)), 0px 1px 2px 0px light-dark(rgba(0, 0, 0, 0.06),rgba(255, 255, 255, 0.1))',
    md: '0px 3px 7px 0px light-dark(rgba(0, 0, 0, 0.1),rgba(255, 255, 255, 0.15)), 0px 2px 4px 0px light-dark(rgba(0, 0, 0, 0.1),rgba(255, 255, 255, 0.15))',
    lg: '0px 0px 6px -2px light-dark(rgba(0, 0, 0, 0.15),rgba(255, 255, 255, 0.3)), 0px 6px 15px -3px light-dark(rgba(0, 0, 0, 0.15),rgba(255, 255, 255, 0.3))',
    none: 'none',
    'md-inverted': '0px -3px 7px 0px light-dark(rgba(0, 0, 0, 0.1),rgba(255, 255, 255, 0.15)), 0px -2px 4px 0px light-dark(rgba(0, 0, 0, 0.1),rgba(255, 255, 255, 0.15))'
};

exports.boxShadow = boxShadow;
//# sourceMappingURL=boxShadow.js.map
